import React from 'react';
import { motion } from 'framer-motion';
import { infoSources, painPoints, selfQuestions } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="¿Te resulta familiar esta situación?" className="bg-obsidian text-white" data-id="element-151" data-mp="2lp55ksdk54u7">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "20px"
    }} data-id="element-152" data-mp="26wlggvn8sxvr">
        <div className="max-w-3xl" data-id="element-153" data-mp="1xxzq4ebj4ekf">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-none sm:text-6xl" data-id="element-154" data-mp="1xwopuohaloy2">
            ¿Te resulta familiar esta situación?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-white/75" data-id="element-155" data-mp="1nztolxtmxag3">
            Estás preparando un triatlón, pero cada vez que intentas organizar tu preparación terminas
            abrumado por la cantidad de información disponible.
          </p>
        </div>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-14" data-id="element-156" data-mp="3iee3ftv9ybrk">
          <div data-id="element-157" data-mp="3nbcvm6vdo8n4">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/45" data-id="element-158" data-mp="3nbwfht4l973s">Tienes</p>
            <ul className="mt-4 flex flex-wrap gap-2" data-id="element-159" data-mp="1yyu7bbuwvzbo">
              {infoSources.map(s => <li key={s} className="rounded-lg border border-white/15 px-3 py-1.5 text-sm text-white/80" data-id="element-160" data-mp="1u0smaldxdpxk">
                  {s}
                </li>)}
            </ul>
            <p className="mt-5 text-lg font-semibold text-ember" data-id="element-161" data-mp="23qveijd82zuu">Pero no necesariamente están conectados entre sí.</p>
          </div>
          <div data-id="element-162" data-mp="1g2lxrvuv92ak">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/45" data-id="element-163" data-mp="1g22ot4n71o8o">Y empiezas a preguntarte</p>
            <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-164" data-mp="1b52jwx22yrj5">
              {selfQuestions.map(q => <li key={q} className="flex gap-2.5 text-[15px] leading-snug text-white/80" data-id="element-165" data-mp="1p0egl9zsqs2p">
                  <span className="font-bold text-ember" aria-hidden="true" data-id="element-166" data-mp="1k5iknyrfvkkb">?</span>
                  {q}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-14 border-y border-white/10 py-10 text-center" data-id="element-167" data-mp="2vhrs5m73x8j6">
          <p className="text-lg text-white/60" data-id="element-168" data-mp="1t5ya2olh0l4l">El problema no siempre es la falta de motivación.</p>
          <p className="mt-2 font-display text-4xl font-extrabold uppercase leading-none sm:text-6xl" data-id="element-169" data-mp="1y3gm4nusbggt">
            Muchas veces, es la falta de un <span className="text-electric" data-id="element-170" data-mp="226mo3jav6lhh">sistema de organización</span>.
          </p>
        </div>

        <ol className="divide-y divide-white/10" data-id="element-171" data-mp="2744zdgcctcsn">
          {painPoints.map(({
          icon: Icon,
          title,
          body,
          list,
          resolve
        }) => <motion.li key={title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-4 py-9 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-12" data-id="element-172" data-mp="1efqzev1pg6eg">
              <div className="flex items-start gap-4" data-id="element-173" data-mp="qqei17w84s12">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-ember/30 bg-ember/10 text-ember" data-id="element-174" data-mp="vozj19javfqk">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-175" data-mp="o5grufzwkg6w" />
                </span>
                <h3 className="pt-1 font-display text-2xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-176" data-mp="j7opes1mtbog">
                  {title}
                </h3>
              </div>
              <div className="space-y-3 text-[15px] leading-relaxed text-white/70 lg:pt-1.5" data-id="element-177" data-mp="a5fi0b1ntyfa">
                {body.map(b => <p key={b} data-id="element-178" data-mp="585wv7lb08x9">{b}</p>)}
                {list && <ul className="space-y-1.5" data-id="element-179" data-mp="5974t370wfar">
                    {list.map(item => <li key={item} className="flex gap-2.5" data-id="element-180" data-mp="f31qv0vorey">
                        <span className="text-ember" aria-hidden="true" data-id="element-181" data-mp="3rm74vetwjti3">—</span>
                        {item}
                      </li>)}
                  </ul>}
                {resolve && <p className="font-semibold text-white" data-id="element-182" data-mp="3imalnsqa7muf">{resolve}</p>}
              </div>
            </motion.li>)}
        </ol>

        <div className="mt-8 rounded-2xl bg-electric px-6 py-9 text-center" data-id="element-183" data-mp="3dmnzuuwe0ya0">
          <p className="mx-auto max-w-3xl font-display text-2xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-184" data-mp="1hk19qqasrmer">
            Si te identificas con estas situaciones, Sigma Smart™ tiene una propuesta para ayudarte a organizar mejor tu preparación.
          </p>
        </div>
      </div>
    </section>;
}